export enum OrganizationStatus {
  ACTIVE = 'active',
  PENDING = 'pending',
}
